import { combineReducers } from "redux";
import { listOfExpensesReducer } from "./slices/listOfExpensesSlice";
import { pendingRequestsReducer } from "./slices/pendingRequestsSlice";
import { projectCodesReducer } from "./slices/projectCodesSlice";
import { expenseCodesReducer } from "./slices/expenseCodesSlice";
import { departmentsReducer } from "./slices/departmentsSlice";
import { currenciesReducer } from "./slices/currenciesSlice";
import { rolesReducer } from "./slices/rolesSlice";
import { permissionsReducer } from "./slices/permissionsSlice";
import { usersReducer } from "./slices/usersSlice";
import { notificationsReducer } from "./slices/notificationsSlice";
import { settingsReducer } from "./slices/settingsSlice";
import { fileUploadReducer } from "./slices/fileUploadSlice";
import { expenseCalendarControlsReducer } from "./slices/expenseCalendarControlsSlice";
import { addNewExpenseReducer } from "./slices/addNewExpenseSlice";
import { dashboardReducer } from "./slices/dashboardSlice";
import authReducer from "./slices/authSlice";
import masterDataReducer from "./slices/masterDataSlice";
import { vendorsReducer } from "./slices/vendorsSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  dashboard: dashboardReducer,
  addNewExpenses: addNewExpenseReducer,
  listOfExpenses: listOfExpensesReducer,
  pendingRequests: pendingRequestsReducer,
  projectCodes: projectCodesReducer,
  expenseCodes: expenseCodesReducer,
  departments: departmentsReducer,
  currencies: currenciesReducer,
  roles: rolesReducer,
  permissions: permissionsReducer,
  users: usersReducer,
  notifications: notificationsReducer,
  settings: settingsReducer,
  fileUpload: fileUploadReducer,
  expenseCalendarControls: expenseCalendarControlsReducer,
  masterData:masterDataReducer,
  vendors: vendorsReducer
});

export default rootReducer;
